import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

export const Trigger = styled(ButtonPlain)`
	align-items: center;
	background-color: transparent;
	border: 0;
	border-radius: 50%;
	color: inherit;
	cursor: pointer;
	display: flex;
	justify-content: center;
	margin: 0;
	padding: 0;

	&:focus-visible {
		outline: 2px solid ${helpers.color.white};
		outline-offset: 4px;
	}
`
